import uuid from "react-uuid";

let initialState = {
  widgetGraphConfig: {
    data_source: null,
    x_axis: null,
    y_axis: {
      y_series_1: {
        attribute: null,
        aggregation: null,
      },
    },
    y_axis_settings: [],
    breakdown_by: [],
    filter_by: [],
    fields: [],
    chart_type: "line",
    duration: null,
    brands: null,
    filters: [],
    show_marker: true,
    card_position: "Top",
    card_limit: 5,
    card_settings: [
      {
        card_id: uuid(),
        card_name: 1,
        card_value: null,
        x_axis: null,
        y_series: null,
        response: [],
      },
    ],
    rich_fields_content: null,
    chart_settings: {
      global_data_label: false,
      show_details_on_card: false,
      show_3d: false,
      settings_3d: null,
      show_horizontal_view: false,
      show_label_names: true,
      is_stacked: true,
      is_stacked_disabled: false,
      data_count_card: true,
      duration_comparison: false, // This is used for only KPI
      show_previous_duration_comparison: false, // This is used for charts
      show_previous_duration_data: false, // This is used for charts
      show_as_median: false, // this is used for scatter chart
      show_peak: true,
      show_valley: true,
      card_percent: true,
      chart_percent: false,
      gradient_color: false,
      group_line_agg: null,
      benchmark_line: false,
      benchmark_static_value: null,
      duplicate_for_brands: false,
      total_row: false,
      split_cards: true,
      top_posts_in_cards: false,
      show_header: true,
      wordcloud_color: "0",
      // border_sentiment: false,
      // dynamic_radius: true,
      planned_value: null,
      chart_styles: null,
      cluster_chart_type: null,
      cluster_style: null,
      grid_config: {
        columnConfig: null,
      },
      total_count_flag: false,
    },
    chart_property: {
      chart_name: null,
      legend_position: "bottom",
      show_legend: true,
      y_axis_mode: 2,
      no_of_top_posts: 1,
      screen_width: window?.innerWidth,
      screen_height: window?.innerHeight,
    },
    widget_description: null,
    dragDataType: {
      varchar: false,
      int: false,
      datetime: false,
      json: false,
    },
    edit_fields: {
      boolValue: false,
      series: "",
      data: "",
    },
    order_by: null,
    custom_attribute: {
      name: null,
      description: null,
      formula: null,
      custom_column: [
        {
          parameters: {
            attribute: null,
            display_name: null,
            data_type: null,
            selected: true,
          },
          operator: { value: null, selected: false },
          pair: {
            parameters: {
              attribute: null,
              display_name: null,
              data_type: null,
              selected: false,
            },
            numeric: { value: null, selected: false },
          },
          combined_operator: {
            value: null,
            selected: false,
          },
        },
      ],
    },
    widgetResetState: false,
    trends: null,
    filter_by_data: [],
    // This is used for filter by dropdown in widget header
    filter_dropdown: [],
    filter_by_dropdown: [],
    filter_by_dropdown_data: [],
    postcard_pills_filter: null,
    tags: [],
    chart_attributes_field_config: {
      selected_field: null,
      data: [],
      open_chart_setting_flag: false,
      selected_chart_type: null,
    },
    multilevel_breakdown: null,
    deep_dive_on: null,
  },
};
const GraphConfig = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DATASOURCE":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_X_ATTRIBUTE":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_Y_ATTRIBUTE":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_FILTER_OBJ":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_DURATION":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_BRANDS":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_CHART_TYPE":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_TAGS":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_FILTER_BY_DROPDOWN":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_RICH_FIELDS":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_RICH_FIELDS_CONTENT":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_CHART_NAME":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_CHART_DESCRIPTION":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_LEGEND_POSITION":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_SHOW_LEGEND":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_NUMBER_TOP_POSTS":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_MAKER_SHOW_HEADER":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GLOBAL_DATA_LABEL":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GLOBAL_SHOW_DETAILS_ON_CARD":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GLOBAL_HORIZONTAL_VIEW":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_DUPLICATE_FOR_BRANDS":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_SHOW_AS_MEDIAN":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_DATA_LABEL_IN_PERCENT":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GRADIENT_COLOR":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GLOBAL_STACKED":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GLOBAL_STACKED_DISABLED":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GLOBAL_DURATION_COMPARISION":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GLOBAL_DURATION_COMPARISION_FOR_CHART":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GLOBAL_DURATION_DATA_FOR_CHART":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_SHARE_OF_DATA":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_SHOW_MARKER":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_DATA_COUNT_CARD":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_CARD_POSITION":
      return {
        ...state,

        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_CARD_LIMIT":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CARD_SETIINGS":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_Y_AXIS_SCALE":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CARD_SETIINGS_DATA":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_LINE_PROPERTY":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CARD_SETIINGS_CARD_DATA":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CHART_Y_AXIS_SETIINGS_DATA":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CHART_Y_AXIS_SCALE":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CHART_Y_AXIS_MAP_AT":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CHART_Y_AXIS_MEDIAN":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CHART_Y_AXIS_MODE":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CHART_EDIT_FIELDS":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_POST_CARD_ORDER_BY":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_POLIFIC_ORDER_BY_ATTRIBUTE":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CARD_SETTING_SERIES_AGGREGATION":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CARD_SETTING_BENCHMARK_LINE":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_CARD_SETTING_BENCHMARK_STATIC_VALUE":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_POST_CARD_FILTERS_BY_DATA":
      return {
        ...state,
        filters_by_data: action.widgetGraphConfig,
      };
    case "SET_WIDGET_TOTAL_ROW":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_MAKER_SPLIT_CARDS":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_MAKER_TOP_POSTS":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WORDCLOUD_COLOUR":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_MAKER_DYNAMIC_RADIUS":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_MAKER_BORDER_SENTIMENT":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_MAKER_DATA_SOURCE":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_ENABLE_3D":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_SHOW_MIN_MAX_DATA":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_SHOW_PEAK":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_SHOW_VALLEY":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_CHART_STYLES_OPTION":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    case "SET_WIDGET_GRID_CONFIG":
      return {
        ...state,
        widgetGraphConfig: action.widgetGraphConfig,
      };
    default:
      return state;
  }
};

export default GraphConfig;
